export default "__VITE_ASSET__cres4tNw__"